<template>
  <panel content="想知道您的潜在客户有哪些？"
         :url="url"> </panel>
</template>

<script>
import panel from './panel-1'
export default {
  components: {
    panel,
  },
  data () {
    return {
      url: require('@/assets/access_images/access-form.png')
    }
  },
}
</script>

<style lang="scss" scoped>
</style>